/****************************************************************************************************************
* ©2019 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
import { Directive, TemplateRef, ViewContainerRef, Input, EmbeddedViewRef } from '@angular/core';
import { ProfileService } from '../../core/services/profile.service';

@Directive({
    selector: '[PreAuthorize]',
    standalone: false
})
export class AuthorizeDirective {

    private _context: PreAuthorizeContext = new PreAuthorizeContext();
    private _mainTemplateRef: TemplateRef<any> | null;
    private _mainViewRef: EmbeddedViewRef<any> | null;
    private _elseTemplateRef: TemplateRef<any> | null;
    private _elseViewRef: EmbeddedViewRef<any> | null;

    constructor(private template: TemplateRef<any>, private viewContainer: ViewContainerRef,
        private profileService: ProfileService) {
        this._mainTemplateRef = template;
    }

    @Input() set PreAuthorize(action: any) {
        this._context.action = action;
        this.updateView();
    }

    @Input() set PreAuthorizeElse(templateRef: TemplateRef<any> | null) {
        assertTemplate('PreAuthorizeElse', templateRef);
        this._elseTemplateRef = templateRef;
        this.updateView();
    }
    private validate(): boolean {
        let actions: string[] = this.profileService.actions;
        if (!actions || !this._context.action)
            return false;
        // if (this._context.action instanceof Array) {
        //     let actionArray = this._context.action;
        //     let i = 0;
        //     for (i = 0; i < actionArray.length; i++) {
        //         if (typeof actionArray[i] !== "string")
        //             throw new Error(`${actionArray[i]} must be a string`);
        //         if (!actions.includes(actionArray[i]))
        //             break;
        //     }
        //     if (i === actionArray.length)
        //         return true;
        //     else
        //         return false;
        // } else 
        if (typeof this._context.action === "string") {
            return (actions.indexOf(this._context.action) > -1);
        }
        // throw new Error(`${this._context.action} must be a string or a string array`);
        throw new Error(`${this._context.action} must be a string`);
    }

    private updateView() {
        if (this.validate()) {
            if (!this._mainViewRef) {
                this.viewContainer.clear();
                this._elseViewRef = null;
                if (this._mainTemplateRef) {
                    this._mainViewRef = this.viewContainer
                        .createEmbeddedView(this._mainTemplateRef, this._context);
                }
            }
        } else {
            if (!this._elseViewRef) {
                this.viewContainer.clear();
                this._mainViewRef = null;
                if (this._elseTemplateRef) {
                    this._elseViewRef = this.viewContainer
                        .createEmbeddedView(this._elseTemplateRef, this._context);
                }
            }
        }
    }

}

export class PreAuthorizeContext {
    public action: any = null;
}

function assertTemplate(property:string, templateRef: TemplateRef<any>|null): void {
    const isTemplateRefOrNull = !!(!templateRef || templateRef.createEmbeddedView);
    if(!isTemplateRefOrNull)
     throw new Error(`${property} must be a TemplateRef, but recieved '${JSON.stringify(templateRef)}'.`);
}

